import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import { validateLoginForm } from './validation'
import { routes } from 'app/routes'
import { Card } from 'app/components/ui/Card'
import { Button } from 'app/components/ui/Button'
import styled from 'styled-components'
import { SmartInput } from 'app/components/formik/Input'
import { Link } from 'react-router-dom'
import revealPasswordIcon from 'static/icons/reveal_password.svg'
import { themeEstra } from 'app/styles/themeEstra'
import { ApiErrorMessage } from 'app/components/ui/form/ApiErrorMessage'

const initialValues = {
  email: '',
  password: '',
}

export type LoginFormValues = typeof initialValues

interface Props {
  onLoginRequest: (values: LoginFormValues) => void
  isLoading: boolean
  errorMessage?: string | null
}
export const FormLogin: React.FC<Props> = ({
  onLoginRequest,
  isLoading,
  errorMessage,
}) => {
  const [revealPassword, setRevealPassword] = useState(false)

  const toggleRevealPassword = () => {
    setRevealPassword(!revealPassword)
  }

  return (
    <Formik
      initialValues={initialValues}
      validate={validateLoginForm}
      onSubmit={values => {
        // send
        onLoginRequest(values)
      }}
    >
      {() => {
        return (
          <Form>
            <Card shadow padding='2rem'>
              {/* EMAIL */}
              <EmailInputGroup>
                <SmartInput
                  label='Email'
                  name='email'
                  type='email'
                  bgColor={themeEstra.color.neutri.grigioBg}
                />
              </EmailInputGroup>

              {/* PASSWORD */}
              <PasswordInputGroup>
                <SmartInput
                  label='Password'
                  name='password'
                  type={revealPassword ? 'text' : 'password'}
                  bgColor={themeEstra.color.neutri.grigioBg}
                  sideButton={
                    <Button
                      variant='grigio'
                      type='button'
                      onClick={() => toggleRevealPassword()}
                    >
                      <img
                        src={revealPasswordIcon}
                        alt='reveal password'
                        width='20px'
                        height='20px'
                      />
                    </Button>
                  }
                />
              </PasswordInputGroup>

              <Link to={routes.forgotPassword.makeUrl()}>
                Ho dimenticato la password
              </Link>
              <ButtonWrapper>
                {errorMessage && (
                  <LoginError outline customMessage={errorMessage}></LoginError>
                )}
                <Button type='submit' disabled={isLoading}>
                  ENTRA
                </Button>
              </ButtonWrapper>
            </Card>
          </Form>
        )
      }}
    </Formik>
  )
}

const EmailInputGroup = styled.div`
  margin-bottom: 2rem;
`

const PasswordInputGroup = styled.div`
  margin-bottom: 1rem;
`

const ButtonWrapper = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const LoginError = styled(ApiErrorMessage)`
  margin-bottom: 1rem;
`
